<h2 mat-dialog-title>{{ 'CUSTOMERS.ACTION_BUTTON.SEND_REVIEW_REQUEST' | translate }}</h2>
<mat-dialog-content [formGroup]="form">
  <glxy-form-row>
    <glxy-form-field class="col-xs-12 col-sm-6">
      <glxy-label>{{ 'COMMON.FIELD_LABELS.FIRST_NAME' | translate }}</glxy-label>
      <input formControlName="firstName" matInput />
      @if (form.get('firstName').hasError('invalidName') && form.get('firstName').touched) {
        <glxy-error>
          {{ 'ADD_CUSTOMER_FORM.INVALID_CHARACTERS' | translate }}
        </glxy-error>
      }
    </glxy-form-field>
    <glxy-form-field class="col-xs-12 col-sm-6">
      <glxy-label>{{ 'COMMON.FIELD_LABELS.LAST_NAME' | translate }}</glxy-label>
      <input formControlName="lastName" matInput />
      @if (form.get('lastName').hasError('invalidName') && form.get('lastName').touched) {
        <glxy-error>
          {{ 'ADD_CUSTOMER_FORM.INVALID_CHARACTERS' | translate }}
        </glxy-error>
      }
    </glxy-form-field>
  </glxy-form-row>
  <glxy-form-field>
    <glxy-label>{{ 'COMMON.FIELD_LABELS.EMAIL' | translate }}</glxy-label>
    <input formControlName="emailAddress" matInput />
    @if (form.get('emailAddress').hasError('invalidEmail')) {
      <glxy-error>
        {{ 'ADD_CUSTOMER_FORM.INVALID_EMAIL_ADDRESS' | translate }}
      </glxy-error>
    }
    @if (form.get('emailAddress').hasError('alreadyExists')) {
      <glxy-error>
        {{ 'ADD_CUSTOMER_FORM.EMAIL_ALREADY_EXISTS' | translate }}
      </glxy-error>
    }
  </glxy-form-field>
  <glxy-form-field>
    <glxy-label>{{ 'COMMON.FIELD_LABELS.PHONE_NUMBER' | translate }}</glxy-label>
    <input formControlName="phoneNumber" matInput />
    @if (form.get('phoneNumber').hasError('invalidPhoneNumber')) {
      <glxy-error>
        {{ 'ADD_CUSTOMER_FORM.INVALID_PHONE_NUMBER' | translate }}
      </glxy-error>
    }
    @if (form.get('phoneNumber').hasError('alreadyExists')) {
      <glxy-error>
        {{ 'ADD_CUSTOMER_FORM.PHONE_ALREADY_EXISTS' | translate }}
      </glxy-error>
    }
  </glxy-form-field>
  <glxy-form-field>
    <glxy-label>{{ 'FIELD_LABELS.TAG' | translate }}</glxy-label>
    <input formControlName="tag" matInput />
  </glxy-form-field>
  <glxy-form-row>
    <glxy-form-field class="col-xs-12 col-sm-6">
      <glxy-label>{{ 'COMMON.FIELD_LABELS.EMPLOYEE_FIRST_NAME' | translate }}</glxy-label>
      <input formControlName="employeeFirstName" matInput />
      @if (form.get('employeeFirstName').hasError('invalidName') && form.get('employeeFirstName').touched) {
        <glxy-error
          >
          {{ 'ADD_CUSTOMER_FORM.INVALID_CHARACTERS' | translate }}
        </glxy-error>
      }
    </glxy-form-field>
    <glxy-form-field class="col-xs-12 col-sm-6">
      <glxy-label>{{ 'COMMON.FIELD_LABELS.EMPLOYEE_LAST_NAME' | translate }}</glxy-label>
      <input formControlName="employeeLastName" matInput />
      @if (form.get('employeeLastName').hasError('invalidName') && form.get('employeeLastName').touched) {
        <glxy-error>
          {{ 'ADD_CUSTOMER_FORM.INVALID_CHARACTERS' | translate }}
        </glxy-error>
      }
    </glxy-form-field>
  </glxy-form-row>
  <glxy-form-field>
    <glxy-label>{{ 'COMMON.FIELD_LABELS.TEMPLATE' | translate }}</glxy-label>
    <mat-select [formControl]="selectedTemplate" [placeholder]="'COMMON.FIELD_LABELS.TEMPLATE' | translate">
      <mat-select-trigger>
        @if (selectedTemplate.value) {
          <span>
            @if (selectedTemplate.value?.templateType === ReviewRequestType.email) {
              <mat-icon>email</mat-icon>
            }
            @if (selectedTemplate.value?.templateType === ReviewRequestType.sms) {
              <mat-icon>smartphone</mat-icon>
            }
            {{ selectedTemplate.value?.name }}
          </span>
        }
      </mat-select-trigger>
      @for (template of filteredTemplates$$ | async; track template) {
        <mat-option [value]="template">
          @if (template.templateType === ReviewRequestType.email) {
            <mat-icon>email</mat-icon>
          }
          @if (template.templateType === ReviewRequestType.sms) {
            <mat-icon>smartphone</mat-icon>
          }
          {{ template.name }}
        </mat-option>
      }
    </mat-select>
    @if (
      (form.get('selectedTemplate').hasError('required') && (hasSmsEnabled$ | async) === false) ||
      (hasSmsEnabled$ | async) === null
      ) {
      <glxy-error
        >
        {{ 'ADD_CUSTOMER_FORM.EMAIL_REQUIRED_FOR_TEMPLATE' | translate }}
      </glxy-error>
    }
    @if (form.get('selectedTemplate').hasError('required') && (hasSmsEnabled$ | async)) {
      <glxy-error>
        {{ 'ADD_CUSTOMER_FORM.EMAIL_OR_PHONE_REQUIRED_FOR_TEMPLATE' | translate }}
      </glxy-error>
    }
  </glxy-form-field>
</mat-dialog-content>
@if (
  (reachedExpressEmailLimit$ | async) === false || (reachedExpressEmailLimit$ | async) === null) {
  <mat-dialog-actions
    >
    <div [ngClass]="{ 'action-bar-error': customerWithEmailExists || customerWithPhoneExists }">
      @if (customerWithEmailExists) {
        <span>
          {{ 'ADD_CUSTOMER_FORM.EMAIL_ALREADY_EXISTS_WITH_LINK' | translate }}
        </span>
      }
      @if (customerWithPhoneExists) {
        <span>
          {{ 'ADD_CUSTOMER_FORM.PHONE_ALREADY_EXISTS_WITH_LINK' | translate }}
        </span>
      }
      @if (customerWithEmailExists || customerWithPhoneExists) {
        <a [href]="customersPageLink">
          {{ 'ADD_CUSTOMER_FORM.GO_TO_CUSTOMERS_LINK' | translate }}
        </a>
      }
    </div>
    <button (click)="close()" [disabled]="savingInProgress" mat-stroked-button>
      {{ 'COMMON.ACTION_LABELS.CANCEL' | translate }}
    </button>
    <button (click)="submitForm()" [disabled]="savingInProgress || !form.valid" color="primary" mat-flat-button>
      {{ 'COMMON.ACTION_LABELS.SEND' | translate }}
    </button>
  </mat-dialog-actions>
} @else {
  <mat-dialog-actions class="error-background">
    <div class="send-review-request-warning">
      <mat-icon class="error-icon">error</mat-icon>
      <div>
        {{ 'CUSTOMERS.PREVIEW_EMAIL.NO_EMAIL_FOR_EXPRESS_ERROR' | translate }}
      </div>
    </div>
    <button (click)="openUpgradeDialog()" color="primary" mat-flat-button>
      {{ 'CUSTOMERS.PREVIEW_EMAIL.UPGRADE' | translate }}
    </button>
  </mat-dialog-actions>
}

